import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { ConfirmModalModel } from 'shared/lib';
import { ModalFormProps, createModalForm } from '../modal-form';

export type ConfirmModalProps = ModalFormProps;

export const createConfirmModal = <TModalData, TParams, TResponse>(
	confirmModalModel: ConfirmModalModel<TModalData, TParams, TResponse>,
) => {
	const ModalForm = createModalForm<TModalData, Record<string, never>>(confirmModalModel);

	const ConfirmModalBase = forwardRef<HTMLDivElement, ConfirmModalProps>(
		({ submitButtonProps, children, ...props }, ref) => {
			const pending = useUnit(confirmModalModel.mutation.$pending);

			return (
				<ModalForm
					ref={ref}
					variant='confirm'
					size='sm'
					submitButtonProps={{
						loading: pending,
						...submitButtonProps,
					}}
					{...props}
				>
					{children}
				</ModalForm>
			);
		},
	);

	return Object.assign(ConfirmModalBase, {
		Root: ModalForm.Root,
		Overlay: ModalForm.Overlay,
		Content: ModalForm.Content,
		Form: ModalForm.Form,
		Header: ModalForm.Header,
		Title: ModalForm.Title,
		CloseButton: ModalForm.CloseButton,
		Body: ModalForm.Body,
		Footer: ModalForm.Footer,
		CancelButton: ModalForm.CancelButton,
		SubmitButton: ModalForm.SubmitButton,
		Button: ModalForm.Button,
		ActionIcon: ModalForm.ActionIcon,
	});
};
